import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../store_redux'
import FormControlLabelAtom from '../formcontrol_label/formcontrol_label.atom'
import SwitchAtom from '../switch/switch.atom'
import {
  setCustomTheme,
  setDefaultTheme,
} from '../../../store_redux/reducer/theme.reducer'

const SwitchThemeAtom = function () {
  const themeMode = useSelector((state: RootState) => state.theme.mode)
  const dispatch = useDispatch()

  const switchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(e.target.checked ? setCustomTheme() : setDefaultTheme())
  }
  return (
    <FormControlLabelAtom
      control={
        <SwitchAtom checked={themeMode === 'CUSTOM'} onChange={switchHandler} />
      }
      label="Switch Theme"
    />
  )
}
export default SwitchThemeAtom
